module.exports = __webpack_public_path__ + "img/data.cd231634.png";